const AUTHORIZATION_PATH = '/integrations/chathub/authorize'
const MAX_REQUEST_JWT_LENGTH = 4096

let requestJwt: string | null = null

export function captureAuthorizationRequest(input: {
  pathname: string
  hash: string
  clearHash: () => void
}): void {
  requestJwt = null
  if (input.pathname !== AUTHORIZATION_PATH) return

  input.clearHash()
  if (!input.hash.startsWith('#')) return
  const segments = input.hash.slice(1).split('&')
  if (segments.length !== 1) return
  const separator = segments[0]?.indexOf('=') ?? -1
  if (separator < 0) return
  let key: string
  let candidate: string
  try {
    key = decodeURIComponent(segments[0]?.slice(0, separator) ?? '')
    candidate = decodeURIComponent(segments[0]?.slice(separator + 1) ?? '')
  } catch {
    return
  }
  if (key !== 'request') return
  if (!candidate || candidate.length > MAX_REQUEST_JWT_LENGTH) return
  requestJwt = candidate
}

export function consumeAuthorizationRequest(): string | null {
  const value = requestJwt
  requestJwt = null
  return value
}
